export default __webpack_public_path__ + "static/media/releasing.2cd80e23.gif";